// Initialize Sentry FIRST - before any other imports
import { initSentry } from "@/lib/sentry";
initSentry();

import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Set global axios defaults to prevent hanging requests
axios.defaults.timeout = 30000; // 30 second default timeout (increased from 15s for slower connections)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
